import { render, staticRenderFns } from "./Different.vue?vue&type=template&id=de74a73e&scoped=true&"
import script from "./Different.vue?vue&type=script&lang=js&"
export * from "./Different.vue?vue&type=script&lang=js&"
import style0 from "./Different.vue?vue&type=style&index=0&id=de74a73e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de74a73e",
  null
  
)

export default component.exports